import React from 'react';
import styled from 'styled-components';

import speaker from '../asset/img/common/speaker_icon.svg';
import Typography from './common/Typography';

const InfoBannerStyled = styled.div`
  border-radius: 10px;
  background: var(--GrayScale-100);
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 4px;
`;

const InfoBanner = ({ title = '', description = '' }) => {
  return (
    <InfoBannerStyled>
      <div className="displayFlex" style={{ gap: '8px', alignItems: 'flex-start' }}>
        <img alt={description || title} src={speaker} />
        <Typography variant="body2Bold">{title}</Typography>
      </div>
      <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
        {description}
      </Typography>
    </InfoBannerStyled>
  );
};

export default InfoBanner;
